/*
 * Secondhand Südtirol – Shopifys bestehenden Cart-Drawer benutzen.
 * Nicht zusätzlich sh-cart.liquid aus dem alten Testpaket installieren.
 * Die realen Versandpreise werden AUSSCHLIESSLICH im Shopify Checkout festgelegt.
 */
(() => {
  'use strict';

  function basePath() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return document.documentElement.lang.toLowerCase().startsWith('it') ? '/it/' : '/';
  }

  function messageFor(code) {
    const it = document.documentElement.lang.toLowerCase().startsWith('it');
    if (code === 'stock') return it
      ? 'Questo articolo potrebbe essere già esaurito o nel carrello. Controlla il carrello.'
      : 'Dieser Artikel ist möglicherweise bereits ausverkauft oder im Warenkorb. Bitte Warenkorb prüfen.';
    return it
      ? 'Impossibile aggiungere il prodotto. Riprova.'
      : 'Produkt konnte nicht hinzugefügt werden. Bitte erneut versuchen.';
  }

  function showError(text) {
    // No HTML interpolation: message text is displayed safely as plain text.
    let notice = document.getElementById('sh-native-cart-error');
    if (!notice) {
      notice = document.createElement('div');
      notice.id = 'sh-native-cart-error';
      notice.setAttribute('role', 'alert');
      notice.style.cssText = 'position:fixed;left:12px;right:12px;bottom:85px;max-width:520px;margin:0 auto;z-index:2147483647;background:#14120d;color:#fff;border:2px solid #f0c02d;border-radius:12px;padding:15px 18px;box-shadow:0 10px 30px #0005;font:600 14px/1.45 system-ui,sans-serif;';
      document.body.appendChild(notice);
    }
    notice.textContent = text;
  }

  async function addToNativeCart(button) {
    const variantId = Number(button.getAttribute('data-variant-id'));
    if (!Number.isSafeInteger(variantId) || variantId < 1) {
      showError(messageFor('generic'));
      return;
    }
    if (button.dataset.shCartLoading === '1') return;

    button.dataset.shCartLoading = '1';
    button.setAttribute('aria-busy', 'true');
    const originalOpacity = button.style.opacity;
    button.style.opacity = '0.65';

    try {
      const root = basePath();
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });
      if (!response.ok) {
        showError(messageFor(response.status === 422 ? 'stock' : 'generic'));
        return;
      }

      // Use the theme's existing drawer methods, its own items/footer snippets, and icon refresh.
      const nativeCart = document.getElementById('cart-sidebar');
      if (nativeCart && typeof nativeCart.reload === 'function' && typeof nativeCart.open === 'function') {
        try {
          await nativeCart.reload();
          nativeCart.open(button);
          return;
        } catch (error) {
          // Added product is still in Shopify cart; show the reliable cart page as fallback.
          console.warn('Native cart drawer refresh failed:', error);
        }
      }
      window.location.assign(root + 'cart');
    } catch (error) {
      console.error('Cart add failed:', error);
      showError(messageFor('generic'));
    } finally {
      button.dataset.shCartLoading = '0';
      button.removeAttribute('aria-busy');
      button.style.opacity = originalOpacity;
    }
  }

  // Delegate events: both the normal and sticky mobile CTA are supported.
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('[data-sh-add-to-cart]');
    if (!button) return;
    event.preventDefault();
    if (button.getAttribute('aria-disabled') === 'true') {
      showError(messageFor('stock'));
      return;
    }
    addToNativeCart(button);
  });
})();
